var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.668C20 12.8771 18.2092 14.668 16 14.668C13.7908 14.668 12 12.8771 12 10.668C12 8.45884 13.7908 6.66797 16 6.66797C18.2092 6.66797 20 8.45884 20 10.668Z",
    stroke: "#243235",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 5.33203C23.5421 5.33203 25.333 7.1229 25.333 9.33203C25.333 10.9628 24.357 12.3657 22.9574 12.9884",
    stroke: "#243235",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2858 18.668H13.7143C10.5584 18.668 8 21.2264 8 24.3822C8 25.6446 9.02335 26.668 10.2857 26.668H21.7143C22.9767 26.668 24 25.6446 24 24.3822C24 21.2264 21.4416 18.668 18.2858 18.668Z",
    stroke: "#243235",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6191 17.332C26.775 17.332 29.3334 19.8904 29.3334 23.0463C29.3334 24.3087 28.3101 25.332 27.0477 25.332",
    stroke: "#243235",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 5.33203C8.45786 5.33203 6.66699 7.1229 6.66699 9.33203C6.66699 10.9628 7.6429 12.3657 9.04257 12.9884",
    stroke: "#243235",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95271 25.332C3.69034 25.332 2.66699 24.3087 2.66699 23.0463C2.66699 19.8904 5.22537 17.332 8.38127 17.332",
    stroke: "#243235",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersActive);
export default __webpack_public_path__ + "static/media/users_active.b2e2f09b5ccbf968900fe31b48af81c1.svg";
export { ForwardRef as ReactComponent };